import React, { Fragment, useEffect, useState } from "react";
import HeaderButtonGroup from "../../components/header-button-group/HeaderButtonGroup";
import ListSearchGroup from "../../components/list-search-group/ListSearchGroup";
import SubHeader from "../../components/sub-header/SubHeader";
import { DeleteModal } from "../../components/delete-modal/DeleteModalComponent";
import { SellModal } from "../../components/sell-modal/SellModalComponent";
import {
  FaSave,
  FaCloudDownloadAlt,
  FaEye,
  FaEyeSlash,
  FaTrash,
  FaDollarSign,
  FaFunnelDollar,
} from "react-icons/fa";
import {
  publishTemplate,
  unpublishTemplate,
  updateActiveTemplate,
  updateAndPublishTemplate,
  deleteTemplate,
  publishProduct,
  unpublishProduct,
  updateTemplateAndPublishProduct,
} from "../../redux/template/TemplateThunk";
import { connect } from "react-redux";
import Spinner from "baseui/icon/spinner";
import { StyledLink } from "baseui/link";
import { withStyle } from "baseui";

const CustomLink = withStyle(StyledLink, {
  color: "#d0d0d0", // A light gray color
  // textDecoration: "none!important",
  ":visited": {
    color: "#d0d0d0",
  },
  ":hover": {
    color: "#f0f0f0", // A slightly brighter gray for hover
  },
});

function TemplateSubHeaderView(props) {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSellModal, setShowSellModal] = useState(false);
  useEffect(() => {
    console.log("object");
  }, [
    props.published,
    props.updateInProgress,
    props.deleteInProgress,
    props.publishInProgress,
    props.sellInProgress,
  ]);

  const onDeleteClick = () => {
    setShowDeleteModal(true);
  };
  const onSaveClick = () => {
    props.updateActiveTemplate();
  };
  const onPublishClick = () => {
    if (props.activeTemplate.published) {
      props.unpublishTemplate(props.activeTemplate.id);
      return;
    }
    if (props.isDirty) {
      props.updateAndPublishTemplate(props.activeTemplate.id);
      return;
    }
    props.publishTemplate(props.activeTemplate.id);
  };

  const handleCreateProduct = (sellDetails) => {
    console.log("Sell details:", sellDetails);
    if (props.isDirty) {
      props.updateTemplateAndSell(props.activeTemplate.id, sellDetails);
      return;
    }
    props.publishProduct(props.activeTemplate.id, sellDetails);    
    setShowSellModal(false);
  };

  const onSellClick = () => {
    if (props.activeTemplate.inMarket) {
      props.unpublishProduct(props.activeTemplate.id);
      return;
    }
    setShowSellModal(true);

  };

  const subHeaderButtons = [
    // {
    //   label: props.inMarket ? "Withdraw" : "Sell",
    //   icon: props.sellInProgress ? Spinner : FaDollarSign,
    //   clickAction: onSellClick,
    //   style: props.sellInProgress || (!props.published && !props.inMarket) || (props.user?.subscription?.plan !== "PREMIUM") ? { opacity: 0.9, disabled: true } : {},
    // },
    {
      label: props.published ? "UnPublish" : " Publish ",
      icon: props.publishInProgress
        ? Spinner
        : props.published
        ? FaEye
        : FaEyeSlash,
      clickAction: onPublishClick,
      style: props.publishInProgress ? { opacity: 0.9, disabled: true } : {},
    },
    // {
    //   label: "Download",
    //   icon: FaCloudDownloadAlt,

    // },
    {
      label: "Save",
      icon: props.updateInProgress ? Spinner : FaSave,
      clickAction: onSaveClick,
      style:
        props.updateInProgress || !props.isDirty
          ? { opacity: 0.9, disabled: true }
          : {}, // Example of reducing opacity while loading
    },
    {
      label: "Delete",
      icon: props.deleteInProgress ? Spinner : FaTrash,
      clickAction: onDeleteClick,
      style: props.deleteInProgress || props.inMarket ? { opacity: 0.9, disabled: true } : {}, // Example of reducing opacity while loading
    },
  ];
  return (
    <Fragment>
      <SubHeader
        leftChildren={
          props.activeTemplate.published && props.activeTemplate?.modelerId ? (
            <CustomLink
              rel="noopener noreferrer"
              target="_blank"
              href={`/modeler/${props.activeTemplate?.modelerId}/home`}
            >
              Link to Modeler
            </CustomLink>
          ) : null
        }
        rightChildren={<HeaderButtonGroup buttons={subHeaderButtons} />}
      />
      <DeleteModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onDeleteConfirm={() => props.deleteTemplate(props.activeTemplate.id)}
      />
      <SellModal
        isOpen={showSellModal}
        onClose={() => setShowSellModal(false)}
        onCreateProduct={handleCreateProduct}
      />      
    </Fragment>
  );
}
const mapStateToProps = (state) => {
  return {
    user: state.user,
    activeTemplate: state.template.activeTemplate,
    published: state.template.activeTemplate?.published,
    sellInProgress: state.template.activeTemplate?.sellInProgress,
    inMarket: state.template.activeTemplate?.inMarket,
    updateInProgress: state.template.activeTemplate?.updateInProgress,
    publishInProgress: state.template.activeTemplate?.publishInProgress,
    deleteInProgress: state.template.activeTemplate?.deleteInProgress,
    isDirty: state.template.activeTemplate?.isDirty,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateActiveTemplate: () => {
      dispatch(updateActiveTemplate());
    },
    publishTemplate: (templateId) => {
      dispatch(publishTemplate(templateId));
    },
    unpublishTemplate: (templateId) => {
      dispatch(unpublishTemplate(templateId));
    },
    deleteTemplate: (templateId) => {
      dispatch(deleteTemplate(templateId));
    },
    updateAndPublishTemplate: (templateId) => {
      dispatch(updateAndPublishTemplate(templateId));
    },
    publishProduct: (templateId, sellDetails) => {
      dispatch(publishProduct(templateId, sellDetails));
    },
    unpublishProduct: (templateId) => {
      dispatch(unpublishProduct(templateId));
    },
    updateTemplateAndSell: (templateId, sellDetails) => {
      dispatch(updateTemplateAndPublishProduct(templateId,sellDetails ));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplateSubHeaderView);
